module.exports = __webpack_public_path__ + "static/media/img.5f9d6360.jpg";